(() => {
	'use strict';

	const selector = '[data-e-collections]';

	class EnterpriseCollections {
		constructor(root) {
			if (root.dataset.eCollectionsReady === 'true') return;

			this.root = root;
			this.viewport = root.querySelector('[data-e-collections-viewport]');
			this.controls = root.querySelector('[data-e-collections-controls]');
			this.previousButton = root.querySelector('[data-e-collections-previous]');
			this.nextButton = root.querySelector('[data-e-collections-next]');
			this.frame = null;
			this.destroyed = false;

			this.onScroll = () => {
				if (this.frame) return;
				this.frame = window.requestAnimationFrame(() => {
					this.frame = null;
					this.update();
				});
			};
			this.onResize = () => this.update();

			root.dataset.eCollectionsReady = 'true';
			this.bind();
			this.update();
		}

		bind() {
			if (!this.viewport || !this.controls) return;

			this.previousButton?.addEventListener('click', () => this.scroll(-1));
			this.nextButton?.addEventListener('click', () => this.scroll(1));
			this.viewport.addEventListener('scroll', this.onScroll, {passive:true});

			if ('ResizeObserver' in window) {
				this.resizeObserver = new ResizeObserver(this.onResize);
				this.resizeObserver.observe(this.viewport);
			} else {
				window.addEventListener('resize', this.onResize);
			}
		}

		scroll(direction) {
			if (!this.viewport) return;
			const amount = Math.max(220, this.viewport.clientWidth * 0.82);
			this.viewport.scrollBy({left: amount * direction, behavior:'smooth'});
		}

		update() {
			if (!this.viewport || !this.controls) return;

			const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
			const hasOverflow = maxScroll > 4;
			this.controls.hidden = !hasOverflow;

			if (!hasOverflow) return;

			const position = Math.abs(this.viewport.scrollLeft);
			if (this.previousButton) this.previousButton.disabled = position <= 4;
			if (this.nextButton) this.nextButton.disabled = position >= maxScroll - 4;
		}

		destroy() {
			this.destroyed = true;
			if (this.frame) window.cancelAnimationFrame(this.frame);
			this.resizeObserver?.disconnect();
			this.viewport?.removeEventListener('scroll', this.onScroll);
			window.removeEventListener('resize', this.onResize);
			delete this.root.eCollectionsInstance;
			delete this.root.dataset.eCollectionsReady;
		}
	}

	const initialize = (scope = document) => {
		const roots = [];
		if (scope.matches?.(selector)) roots.push(scope);
		roots.push(...(scope.querySelectorAll?.(selector) || []));

		roots.forEach((root) => {
			if (!root.eCollectionsInstance) {
				root.eCollectionsInstance = new EnterpriseCollections(root);
			}
		});
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => initialize());
	} else {
		initialize();
	}

	document.addEventListener('shopify:section:load', (event) => initialize(event.target));
	document.addEventListener('shopify:section:unload', (event) => {
		const root = event.target.matches?.(selector) ? event.target : event.target.querySelector?.(selector);
		root?.eCollectionsInstance?.destroy();
	});
})();
